import { ReactElement } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Theme } from '@twilio-paste/core/theme';

import { AppHelmetProvider } from './appHelmetProvider';
import { ExperimentProvider } from './experimentProvider';
import { AppQueriesProvider } from './queriesProvider';
import { AppRouterProvider } from './routerProvider';
import { SearchResultsProvider } from './searchResultsProvider';
import { SupportPlanProvider } from './supportPlanProvider';
import { SystemStatusProvider } from './systemStatusProvider';
import { ToastProvider } from './toastProvider';
import { UserDetailsProvider } from './userProvider';
import { reduxStore } from '../stores/redux';

interface AppProviderProps {
  /**
   * Passing a children prop can be used for passing subcomponents for testing or building stories.
   */
  children?: React.ReactNode;
}

const AppProvider = ({ children }: AppProviderProps): ReactElement => (
  <ReduxProvider store={reduxStore}>
    <Theme.Provider theme="twilio">
      <AppHelmetProvider>
        <AppQueriesProvider>
          <ToastProvider>
            <UserDetailsProvider>
              <ExperimentProvider>
                <SupportPlanProvider>
                  <SystemStatusProvider>
                    <SearchResultsProvider>
                      {children ? children : <AppRouterProvider />}
                    </SearchResultsProvider>
                  </SystemStatusProvider>
                </SupportPlanProvider>
              </ExperimentProvider>
            </UserDetailsProvider>
          </ToastProvider>
        </AppQueriesProvider>
      </AppHelmetProvider>
    </Theme.Provider>
  </ReduxProvider>
);

export default AppProvider;
